import queryString from 'query-string';

interface IQuery {
  [key: string]: any;
}

interface IFilter {
  type: string;
  value: string;
  isFilterOut?: boolean;
}

interface IFilters {
  [key: string]: IFilter;
}

class UrlToStateConverter {
  query: IQuery;

  getSearch() {
    this.query = queryString.parse(window.location.search);
    return this.query.search;
  }

  getSort() {
    this.query = queryString.parse(window.location.search);
    return this.query.ordering;
  }

  getGlobalFilter() {
    this.query = queryString.parse(window.location.search);
    return this.query.global_filter;
    // return this.query.group;
  }

  getAccount() {
    this.query = queryString.parse(window.location.search);
    return this.query.account;
  }

  getFields() {
    this.query = queryString.parse(window.location.search);
    return this.query.fields;
  }

  getFilters() {
    this.query = queryString.parse(window.location.search);
    if (!this.query.filters) {
      return {};
    }
    const filters: IFilters = {};
    const parsedQuery = JSON.parse(this.query.filters);
    for (const filter in parsedQuery) {
      const [filter_name, filter_type] = filter.split('__');
      const filter_value = parsedQuery[filter];

      // BACKWARD COMPATIBILITY: need to support old urls with '__overlap' and '' which become __in
      // if (filter_type === 'overlap' || filter_type === '') {
      //   filters[filter_name] = { type: '__in', value: filter_value };
      // } else {
      filters[filter_name] = { type: `${filter_type ? `__${filter_type}` : ''}`, value: filter_value };
      // }
    }
    return filters;
  }
  getClusterType() {
    this.query = queryString.parse(window.location.search);
    return this.query.clusterType;
  }
  getClusterSort() {
    this.query = queryString.parse(window.location.search);
    return this.query.clusterSort;
  }
  setQueryString(
    filters: IFilters,
    search: string,
    order: string,
    global_filter: string,
    fields: string,
    clusterType: string,
    clusterSort: string,
    investigation_rules?: string,
    investigation_rules_operator?: string,
    filtersWithAndOperator?: string
  ) {
    const url = new URL(window.location.href);

    if (Object.keys(filters).length) {
      const obj: IQuery = {};
      for (const filter in filters) {
        obj[`${filter}${filters[filter].type}`] = filters[filter].value;
      }
      url.searchParams.set('filters', JSON.stringify(obj));
    } else {
      url.searchParams.delete('filters');
    }

    if (clusterType) {
      url.searchParams.set('clusterType', clusterType);
    } else {
      url.searchParams.delete('clusterType');
    }

    if (clusterSort && clusterType) {
      url.searchParams.set('clusterSort', clusterSort);
    } else {
      url.searchParams.delete('clusterSort');
    }

    if (investigation_rules) {
      if (investigation_rules_operator === 'and') {
        url.searchParams.set('rules__all', investigation_rules);
      } else if (investigation_rules_operator === 'or') {
        url.searchParams.set('rules__any', investigation_rules);
      }
    } else {
      url.searchParams.delete('rules__all');
      url.searchParams.delete('rules__any');
    }

    if (filtersWithAndOperator) {
      const f = url.searchParams.get('filters');
      if (f) {
        const parsedFilters = JSON.parse(f);
        if (parsedFilters[filtersWithAndOperator]) {
          parsedFilters[`${filtersWithAndOperator}_and`] = parsedFilters[filtersWithAndOperator];
        }
        delete parsedFilters[filtersWithAndOperator];
        url.searchParams.set('filters', JSON.stringify(parsedFilters));
      }
    } else {
      url.searchParams.delete('technology_versions_labels__intext_and');
      url.searchParams.delete('technology_versions_labels__in_and');
    }

    if (search) {
      url.searchParams.set('search', search);
    } else {
      url.searchParams.delete('search');
    }

    if (fields) {
      url.searchParams.set('fields', fields);
    } else {
      url.searchParams.delete('fields');
    }

    if (order) {
      url.searchParams.set('ordering', order);
    } else {
      url.searchParams.delete('ordering');
    }

    if (global_filter) {
      url.searchParams.set('global_filter', global_filter);
    } else {
      url.searchParams.delete('global_filter');
    }
    window.history.replaceState(null, '', url);
  }
}

export const urlToStateConverter = new UrlToStateConverter();
